import * as Yup from 'yup';

const newRegistro = {
    data: '',
    safra: null,
    pessoa: null,
    naturezaOperacao: null,
    lancaProduto: true,
    movimentaEstoque: false,
    localEstoque: null,
    identificador: null,
    numero: '',
    serie: '',
    total: 0,
    totalItens: 0,
    totalDuplicatas: 0,
    obs: '',
    vendaDup: {
        geraDuplicata: false,
        movimentaFinanceiro: false,
        tipoDuplicata: null,
        contaGerencial: null,
        historico: '',
        tipoPagamento: null,
        contaCaixa: null,
        contaBanco: null,
        numeroParcelas: null,
        competencia: '',
    },
    itens: [],
    parcelas: [],
};

const validation = Yup.object().shape({
    data: Yup.date()
        .required('Este campo é obrigatório'),
    pessoa: Yup.object()
        .typeError('Este campo é obrigatório')
        .shape({
            id: Yup.number()
                .typeError('Este campo é obrigatório')
                .required("Este campo é obrigatório"),
        }),
    localEstoque: Yup.object()
        .typeError('Este campo é obrigatório')
        .shape({
            id: Yup.number()
                .typeError('Este campo é obrigatório')
                .required("Este campo é obrigatório"),
        }),
    naturezaOperacao: Yup.object()
        .typeError('Este campo é obrigatório')
        .shape({
            id: Yup.number()
                .typeError('Este campo é obrigatório')
                .required("Este campo é obrigatório"),
        }),
    vendaDup: Yup.object()
        .shape({
            historico: Yup.string()
                .min(2, 'O campo deve ter no mínimo 2 caracteres')
                .max(255, 'Campo deve ter menos do que 255 caracteres'),
        }),
    parcelas: Yup.array()
        .of(
            Yup.object().shape({
                competencia: Yup.date().required('Este campo é obrigatório'),
                dataVencimento: Yup.date()
                    .required('Este campo é obrigatório'),
                valorTotal: Yup.number()
                    .typeError('Este campo é obrigatório')
                    .positive('Por Favor, informe um valor maior que zero')
                    .required("Este campo é obrigatório"),
                historico: Yup.string()
                    .min(2, 'O campo deve ter no mínimo 2 caracteres')
                    .max(255, 'Campo deve ter menos do que 255 caracteres'),
            })
        ),
    obs: Yup.string()
        .max(1000, 'Campo deve ter menos do que 1000 caracteres'),
});

export const vendaProducaoAgricola = {
    newRegistro,
    validation
}